export const getActionBarStyles = () => ({
  root: {
    width: '100%',
    bottom: 0,
    position: 'fixed',
    borderTop: '1px solid #EDEBE9',
    padding: 16,
    margin: '0 -24px',
  },
});
